<template>
  <section v-if="props.experiences.length > 0" class="bg-beige1 pb-12 md:px-4 md:pb-20" :data-testid="`algolia-recommend-section-${props.recommendationType}`">
    <div class="md:m-auto md:w-11/12 md:max-w-[1216px]">
      <h3 class="group mb-5 ml-4 scroll-mt-20 font-Spectral text-xl tracking-wide md:mb-4 md:ml-0 md:text-[26px] md:leading-[40px]" :class="{ 'md:hover:text-light-fg-accent': props.titleHref }">
        <NuxtLink v-if="props.titleHref" class="flex items-center" :to="props.titleHref">
          {{ props.title }}
          <img alt="" class="h-8 w-8 md:group-hover:hidden" src="@/assets/icon/arrow/right-black.svg" />
          <img alt="" class="hidden h-8 w-8 md:group-hover:block" src="@/assets/icon/arrow/right-gold.svg" />
          <span class="mx-2 flex flex-grow items-center">
            <span class="h-[0.5px] flex-grow bg-beige3"></span>
          </span>
        </NuxtLink>
        <div v-else class="flex items-center">
          {{ props.title }}
          <span class="mx-2 flex flex-grow items-center">
            <span class="h-[0.5px] flex-grow bg-beige3"></span>
          </span>
        </div>
      </h3>
      <!-- 2枚のときは均等グリッド表示、それ以外は横スクロール -->
      <div v-if="props.experiences.length === 2" class="grid grid-cols-1 gap-2 px-4 md:grid-cols-2 md:px-0">
        <OrganismsPagesEnExperienceCard
          v-for="(experience, index) in props.experiences"
          :key="experience.id"
          class="mb-2 overflow-hidden"
          orientation="horizontal"
          theme="light"
          :aria-label="`recommend card ${index}`"
          :data-testid="`recommend-card-${props.recommendationType}-${index}`"
          :disable-carousel-on-sp="true"
          :display-multiple-images="false"
          :experience="experience"
          :on-experience-click="handleCardClick"
        />
      </div>
      <MoleculesHorizontalScrollWrapper v-else scroll-button-box-style="h-[157px] md:h-[228px]">
        <template v-for="(experience, index) in props.experiences" :key="experience.id">
          <div :class="[index === 0 ? 'ml-4 md:ml-0' : '', 'shrink-0']">
            <OrganismsPagesEnExperienceCard
              class="mb-2 w-[280px] shrink-0 overflow-hidden md:w-[360px]"
              orientation="horizontal"
              theme="light"
              :aria-label="`recommend card ${index}`"
              :data-testid="`recommend-card-${props.recommendationType}-${index}`"
              :disable-carousel-on-sp="true"
              :display-multiple-images="false"
              :experience="experience"
              :on-experience-click="handleCardClick"
            />
          </div>
        </template>
      </MoleculesHorizontalScrollWrapper>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { WabunkaExperienceViewModel } from '@/models/wabunka/wabunkaExperience';
import { sendGAWabunkaClickRecommendationEvent, type RecommendationType } from '@/wabunka-src/common/utils/googleAnalytics/events/clickRecommendation';

interface Props {
  title: string;
  titleHref?: string;
  experiences: WabunkaExperienceViewModel[];
  recommendationType: RecommendationType;
  sourceExperienceSlug: string;
}

const props = defineProps<Props>();

const handleCardClick = (clickedExperienceSlug: string) => {
  const position = props.experiences.findIndex((item) => item.slug === clickedExperienceSlug);
  if (position < 0) return;
  sendGAWabunkaClickRecommendationEvent({
    recommendationType: props.recommendationType,
    sourceExperienceSlug: props.sourceExperienceSlug,
    clickedExperienceSlug,
    position,
  });
};
</script>
